import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
 
const {
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  REACT_APP_FIREBASE_APP_ID,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_FIREBASE_VAPID_KEY,
} = process.env;
 
const firebaseConfig = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: REACT_APP_FIREBASE_APP_ID,
  databaseURL: REACT_APP_FIREBASE_DATABASE_URL,
};
 
const app = initializeApp(firebaseConfig);
 
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
 
let realdb = null;
try {
  realdb = getDatabase(app);
} catch (err) {
  console.error("Realtime DB init failed:", err.message);
}
 
let messaging = null;
try {
  if (typeof window !== "undefined" && "serviceWorker" in navigator) {
    messaging = getMessaging(app);
  }
} catch (err) {
  console.warn("Messaging init failed:", err.message);
}
 
const tokenKey = REACT_APP_FIREBASE_VAPID_KEY;
 
export const requestFcmToken = async () => {
  if (!messaging) return null;
  try {
    const token = await getToken(messaging, { vapidKey: tokenKey });
    return token || null;
  } catch (err) {
    console.error("Error retrieving FCM token:", err);
    return null;
  }
};
 
export const onMessageListener = (callback) => {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    callback(payload);
  });
};
 
export { messaging, db, auth, realdb, provider };


